import styled from "styled-components";

export const CadastroPessoasWrapper = styled.div`
    display: flex;
    justify-content: center;
`;